"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationProviderImpl = void 0;
var Utils_1 = require("../../../utils/Utils");
var CoreServiceHelper_1 = require("./CoreServiceHelper");
var RegistrationProviderImpl = (function () {
    function RegistrationProviderImpl(cfg) {
        var _this = this;
        this.cfg = cfg;
        this.COLLECTION = 'RegistrationForm';
        this.log = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.cfg.debuggable) {
                (_a = _this.cfg.logger).log.apply(_a, __spreadArray(["[".concat(_this.env, "] ").concat((0, Utils_1.getTimeString)(), " RegistrationServiceImpl#")], args, false));
            }
        };
        this.sendSmsByFormId = function (formId, content) {
            return CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg).sendSmsByFormId(formId, content);
        };
        this.log('RegistrationServiceImpl# created!');
    }
    RegistrationProviderImpl.prototype.init = function (env, cfg) {
        this.env = env;
        if (cfg) {
            this.cfg = cfg;
        }
        this.log('init# env:', env);
        return Promise.resolve();
    };
    RegistrationProviderImpl.prototype.setDebuggable = function (debuggable) {
        if (this.cfg) {
            this.cfg.debuggable = debuggable;
        }
    };
    RegistrationProviderImpl.prototype.stopAllMonitor = function () {
    };
    RegistrationProviderImpl.prototype.createRegistrationForm = function (form) {
        var _this = this;
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryOne(this.COLLECTION, { formId: form.formId }, {})
            .then(function (response) {
            if (response && response.result) {
                return Promise.reject('formId exist! reject!');
            }
            return CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg).patchRegistrationForm(form);
        });
    };
    RegistrationProviderImpl.prototype.getRegistrationForm = function (formId) {
        var _this = this;
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryOne(this.COLLECTION, { formId: formId }, { _ip: false, priceCouponCodeDiscount: false })
            .then(function (response) {
            return Promise.resolve(response && response.result ? response.result : undefined);
        })
            .catch(function (err) {
            _this.log(err);
            return Promise.resolve(undefined);
        });
    };
    RegistrationProviderImpl.prototype.getGroupCodeUsages = function () {
        var _this = this;
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData('GroupDiscountCodeRecords', {}, {}, {
            _ip: false
        }, undefined)
            .then(function (response) {
            return Promise.resolve(response.result ? response.result : []);
        })
            .catch(function (err) {
            _this.log(err);
            return Promise.resolve([]);
        });
    };
    RegistrationProviderImpl.prototype.getRegistrationForms = function () {
        var _this = this;
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData(this.COLLECTION, {}, {}, {
            _ip: false
        }, undefined)
            .then(function (response) {
            return Promise.resolve(response.result ? response.result : []);
        })
            .catch(function (err) {
            _this.log(err);
            return Promise.resolve([]);
        });
    };
    RegistrationProviderImpl.prototype.removeRegistrationForm = function (form) {
        if (!form || !form.formId) {
            return Promise.reject('form or formId not exist!');
        }
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).removeData(this.COLLECTION, {
            formId: form.formId
        });
    };
    RegistrationProviderImpl.prototype.updateRegistrationForm = function (form) {
        if (!form || !form.formId) {
            return Promise.reject('form or formId not exist!');
        }
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).patchRegistrationForm(form);
    };
    RegistrationProviderImpl.prototype.createSignUpUser = function (signUpUser) {
        if (!signUpUser || !signUpUser.payId || !signUpUser.formId) {
            return Promise.reject('params blank error!');
        }
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).insertSignUpUser(signUpUser);
    };
    RegistrationProviderImpl.prototype.updateSignUpUser = function (signUpUser) {
        var _this = this;
        var updatableDataTmp = {
            studentInfoList: [],
            infoFromSelected: '',
            contactName: '',
            contactEmail: '',
            contactPhone: '',
            remark: ''
        };
        if (!signUpUser || !signUpUser.payId) {
            return Promise.reject('params blank error!');
        }
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryOne('course_registration', {
            payId: signUpUser.payId
        }, { _ip: false })
            .then(function (res) {
            var result = res && res.result ? res.result : undefined;
            if (!result) {
                return Promise.reject('sign up user not found!');
            }
            Object.keys(updatableDataTmp).forEach(function (key) {
                updatableDataTmp[key] = signUpUser[key];
            });
            return CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg).updateData('course_registration', { payId: signUpUser.payId }, updatableDataTmp);
        });
    };
    RegistrationProviderImpl.prototype.upsertDiscountCoupon = function (classIds, code, startTime, endTime, maxCount, remark, target, ccEmailList, expirCcEmailList, payAmount, formIds) {
        if (!code ||
            !startTime ||
            !endTime ||
            !remark ||
            !target ||
            !Array.isArray(classIds) ||
            !Array.isArray(formIds) ||
            !Array.isArray(ccEmailList) ||
            !Array.isArray(expirCcEmailList) ||
            typeof payAmount !== 'number') {
            return Promise.reject('params blank error!');
        }
        var filter = {
            code: code,
            version: '2.1'
        };
        var value = {
            classIds: classIds,
            startTime: startTime,
            endTime: endTime,
            maxCount: maxCount,
            remark: remark,
            target: target,
            ccEmailList: ccEmailList,
            expirCcEmailList: expirCcEmailList,
            payAmount: payAmount,
            formIds: formIds
        };
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).patchData('CouponRecords', filter, value);
    };
    RegistrationProviderImpl.prototype.getDiscountCoupons = function () {
        var _this = this;
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData('CouponRecords', { version: '2.1' }, {}, {}, undefined)
            .then(function (response) {
            return Promise.resolve(response.result ? response.result : []);
        })
            .catch(function (err) {
            _this.log(err);
            return Promise.resolve([]);
        });
    };
    RegistrationProviderImpl.prototype.checkCoupon = function (couponType, classId, code, generalFormId) {
        if (!couponType || !code) {
            return Promise.reject('params blank error!');
        }
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).checkCoupon(couponType, classId, code, generalFormId);
    };
    RegistrationProviderImpl.prototype.getRegisUserNum = function (classIds) {
        var _this = this;
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData('course_registration', {
            $or: [
                { classSelectedId: { $in: classIds } },
                { 'subCoursesSelected.classSelectedId': { $in: classIds } }
            ]
        }, {}, {
            classSelectedId: true,
            subCoursesSelected: true
        }, undefined)
            .then(function (response) {
            return Promise.resolve(response.result ? response.result : []).then(function (classes) {
                var returnObj = {};
                classes.forEach(function (c) {
                    var classSelectedId = c.classSelectedId;
                    var subCoursesSelected = c.subCoursesSelected;
                    if (!returnObj[classSelectedId]) {
                        returnObj[classSelectedId] = 1;
                    }
                    else {
                        returnObj[classSelectedId] += 1;
                    }
                    if (subCoursesSelected) {
                        subCoursesSelected.forEach(function (subclass) {
                            var subClassSelected = subclass.classSelectedId;
                            if (!returnObj[subClassSelected]) {
                                returnObj[subClassSelected] = 1;
                            }
                            else {
                                returnObj[subClassSelected] += 1;
                            }
                        });
                    }
                });
                return returnObj;
            });
        })
            .catch(function (err) {
            _this.log(err);
            return Promise.resolve([]);
        });
    };
    RegistrationProviderImpl.prototype.getSignUpUsers = function (filter, sort) {
        var _this = this;
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData('course_registration', filter, sort, {
            _ip: false
        }, undefined)
            .then(function (response) {
            return Promise.resolve(response.result ? response.result : []);
        })
            .catch(function (err) {
            _this.log(err);
            return Promise.resolve([]);
        });
    };
    RegistrationProviderImpl.prototype.getAllClasses = function () {
        var _this = this;
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData('Classes', {}, {}, {
            _ip: false,
            _id: false
        }, undefined)
            .then(function (response) {
            var classes = response.result ? response.result : [];
            var returnObjs = [];
            classes.forEach(function (c) {
                var findObj = returnObjs.find(function (obj) { return obj.formGeneralId === c.formGeneralId; });
                if (!findObj) {
                    returnObjs.push({
                        formGeneralId: c.formGeneralId,
                        className: c.className,
                        classes: [c]
                    });
                    return;
                }
                findObj.classes.push(c);
            });
            return Promise.resolve(returnObjs);
        })
            .catch(function (err) {
            _this.log(err);
            return Promise.reject(err);
        });
    };
    RegistrationProviderImpl.prototype.getAllGoods = function () {
        var _this = this;
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData('Goods', {}, {}, {
            _ip: false,
            _id: false
        }, undefined)
            .then(function (response) {
            var goods = response.result ? response.result : [];
            return Promise.resolve(goods);
        })
            .catch(function (err) {
            _this.log(err);
            return Promise.reject(err);
        });
    };
    RegistrationProviderImpl.prototype.getAllInformationSources = function () {
        var _this = this;
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData('InformationSources', {}, {}, {
            _ip: false,
            _id: false
        }, undefined)
            .then(function (response) {
            var informationSources = response.result ? response.result : [];
            return Promise.resolve(informationSources);
        })
            .catch(function (err) {
            _this.log(err);
            return Promise.reject(err);
        });
    };
    RegistrationProviderImpl.prototype.getOldStudentData = function (phoneNum) {
        var _this = this;
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData('course_registration', {
            contactPhone: phoneNum,
            'tradeRecords.isPaid': true
        }, {}, {
            studentInfoList: true,
            contactPhone: true,
            contactEmail: true,
            parentEmail: true,
            contactName: true,
            contactConty: true,
            contactAddress: true
        }, '')
            .then(function (response) {
            var result = response && response.result ? response.result : [];
            return Promise.resolve(result);
        })
            .catch(function (err) {
            _this.log(err);
            return Promise.reject(err);
        });
    };
    RegistrationProviderImpl.prototype.syncGoogleForm = function (id) {
        var _this = this;
        if (!id) {
            return Promise.reject('id not found!');
        }
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .syncGoogleForm(id)
            .then(function (response) {
            return Promise.resolve(response ? response.status : 'unknown');
        })
            .catch(function (err) {
            _this.log(err);
            return Promise.reject(err);
        });
    };
    RegistrationProviderImpl.prototype.getAllSyncResults = function () {
        var _this = this;
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData('googleFormSyncResults', {}, {}, {
            _ip: false,
            _id: false
        }, undefined)
            .then(function (response) {
            var result = response.result ? response.result : [];
            return Promise.resolve(result);
        })
            .catch(function (err) {
            _this.log(err);
            return Promise.reject(err);
        });
    };
    return RegistrationProviderImpl;
}());
exports.RegistrationProviderImpl = RegistrationProviderImpl;
//# sourceMappingURL=RegistrationProviderImpl.js.map